import {
    withStyles,
    Container,
    Theme,
    createStyles,
    TableCell,
    TextField,
    makeStyles,
    TableRow,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableBody,
    Button,
    FormControl, InputLabel, Select, MenuItem
} from "@material-ui/core"
import {useState, useEffect, useRef} from "react"
import { NavLink } from "react-router-dom"
import { URL_FOR_API } from "../../constants/constants"
import actionsWithApi from "../../customHooks/actionsWithApi"
import AddCircleIcon from '@material-ui/icons/AddCircle'
import SearchIcon from '@material-ui/icons/Search'
import s from './AllContracts.module.scss'
import Preloader from "../shared/Preloader/Preloader"
import {SearchData} from "../shared/CasesTable/CasesTable";

import {ContractsTableBody, StyledTableCell} from "../ContractsTableBody/ContractsTableBody";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        btn: {
            display: "block",
            margin: "15px auto",
            "&:hover": {
                border: "1px solid #3062A0"
            }
        },
        formControl: {
            width: 200,
            "&:last-child": {
                marginRight: 0
            },
            [theme.breakpoints.down('xs')]: {
                width: "100%",
                marginRight: 0
            }
        },
        navFilters: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            margin: "30px 0",
            gap: 20,
            "& > div": {
                display: "flex",
                flexDirection: "row",
                gap: 20
            }
        },
        searchField: {
            width: 200,
            [theme.breakpoints.down('xs')]: {
                width: "100%",
                marginRight: 0
            }
        },
    }),
);


export type ContractItem = {
    id: number;
    caseId: string;
    dateChange: string;
    contractStatus: string;
    totalDue: number;
    currentContractRiskRatePercent: number;
    daysBeforePriceIncrease: number;
    paidOff: number;
    contractClientId: number;
    contractClientFirstName: string;
    contractClientLastName: string;
    contractAttorneyFirstName: string;
    contractAttorneyId: number;
    contractAttorneyLastName: string;
    contractLawFirmId: number
    contractLawFirmName: string
    contractType: string
    identifier: string
    parentContractId: number | null
    stateId: number
    statusDateChange: string;
    totalAmountOwed: number;
}

export default function AllContracts() {
    const classes = useStyles()

    const [viewMoreLoaderIsActive, setViewMoreLoaderIsActive] = useState<boolean>(false)
    const [caseId, setCaseId] = useState<string>("")
    const [client, setClient] = useState<string>("")
    const [attorney, setAttorney] = useState<string>("")
    const [lawFirm, setLawFirm] = useState<string>("")
    const [searchData, setSearchData] = useState<SearchData>({
        caseId: "",
        client: "",
        attorney: "",
        lawFirm: "",
    })
    const [casesArr, setCassesArr] = useState<ContractItem[]>([])
    const [pageNumber, setPageNumber] = useState<number>(1)
    const [viewMoreBtnIsVisible, setViewMoreBtnIsVisible] = useState<boolean>(true)
    async function getCases(pageNumber: number) {
        try {
            let response = await actionsWithApi("POST", URL_FOR_API + `/api/v1/Contract/list`,
                {
                    ...(searchData.caseId && { caseId: searchData.caseId }),
                    ...(searchData.client && { clientFilter: searchData.client }),
                    ...(searchData.attorney && { attorneyFilter: searchData.attorney }),
                    ...(searchData.lawFirm && { lawFirmFilter: searchData.lawFirm }),
                    pagination: {
                        pageNumber: pageNumber,
                        pageSize: 10,
                        sortingType: 'desc'
                    }
                }
            )
            let newContractsArr = [...response.data];
            setViewMoreBtnIsVisible(newContractsArr.length >= 10);

            setCassesArr(prevContracts =>
                pageNumber === 1 ? newContractsArr : [...prevContracts, ...newContractsArr]
            );
            setViewMoreLoaderIsActive(false)
        }
        catch (error) {
            console.log(error.message)
        }
    }

    const submitSearch = () => {
        setSearchData({
            caseId,
            client,
            attorney,
            lawFirm,
        })
    }

    const resetSearch = () => {
        setCaseId('')
        setClient('')
        setAttorney('')
        setLawFirm('')
        setSearchData({
            caseId: '',
            client: '',
            attorney: '',
            lawFirm: '',
        })
    }

    useEffect(() => {
        getCases(pageNumber)
    }, [pageNumber])

    useEffect(() => {
        getCases(1)
    }, [searchData])

    return (
        <Container maxWidth="lg" className={s["AllContracts"]} >
            <div className={s["AllContracts-Nav"]} style={{ justifyContent: 'flex-end'}}>
                <NavLink to="/create-contract-attorney" className={s["AllContracts-CreateNewRequest"] + " " + classes.formControl}>
                    <AddCircleIcon className={s["AllContracts-CreateNewRequestIcon"]} />
                    <button className={s["AllContracts-CreateNewRequestBtn"]}>Create New Request</button>
                </NavLink>
            </div>
            <div className={classes.navFilters}>
                <div>
                    <label className={classes.formControl}>
                        <TextField className={classes.formControl} label="Case ID" value={caseId} type="text" onChange={(e) => setCaseId(e.target.value + "")} />
                    </label>
                    <label className={classes.formControl}>
                        <TextField className={classes.formControl} label="Client" value={client} type="text" onChange={(e) => setClient(e.target.value + "")} />
                    </label>
                    <label className={classes.formControl}>
                        <TextField className={classes.formControl} label="Attorney" value={attorney} type="text" onChange={(e) => setAttorney(e.target.value + "")} />
                    </label>
                    <label className={classes.formControl}>
                        <TextField className={classes.formControl} label="Law Firm" value={lawFirm} type="text" onChange={(e) => setLawFirm(e.target.value + "")} />
                    </label>
                </div>
                <div>
                    <Button color="secondary" variant="outlined" className={classes.btn} onClick={resetSearch}>
                        Reset
                    </Button>

                    <Button color="primary" variant="contained" className={classes.btn} onClick={submitSearch}>
                        Filter
                    </Button>
                </div>
            </div>
            {!casesArr &&
                <Preloader size="100" position="center" />
            }
            {casesArr &&
                <TableContainer component={Paper}>
                    <Table aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Case ID</StyledTableCell>
                                <StyledTableCell align="center">Date Created</StyledTableCell>
                                <StyledTableCell align="center">Status</StyledTableCell>
                                <StyledTableCell align="center">Amount Due</StyledTableCell>
                                <StyledTableCell align="center">Current Interest Rate</StyledTableCell>
                                <StyledTableCell align="center">Days Until Rate Increase</StyledTableCell>
                                <StyledTableCell align="center">Paid Off</StyledTableCell>
                                <StyledTableCell align="center">Client</StyledTableCell>
                                <StyledTableCell align="center">Attorney</StyledTableCell>
                                <StyledTableCell align="center">Law Firm</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <ContractsTableBody data={casesArr} />
                    </Table>
                </TableContainer>
            }

            {
                casesArr && casesArr.length === 0 && (
                    <h2 style={{ textAlign: "center", margin: '10px 0' }}>Contracts not found</h2>
                )
            }

            {viewMoreLoaderIsActive &&
                <Preloader size="50" position="center" />
            }

            {viewMoreBtnIsVisible && !viewMoreLoaderIsActive &&
                <Button color="primary" variant="outlined" className={classes.btn}
                    onClick={() => {
                        setPageNumber(pageNumber + 1)
                        setViewMoreLoaderIsActive(true)
                    }}>
                    View more
                </Button>
            }
        </Container>
    )
}
